export default __webpack_public_path__ + "static/media/Default.b93a080e.png";